// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"styles_copyIcon__gYHsc"};